import {DailyTransactionTypeEnum, HasFormIdModel, RowStateEnum, TransactionDetailResponseModel} from "../../../models";
import React, {forwardRef, useEffect, useState} from "react";
import {getLabelName} from "../../../utils";
import {useTransactionLoading, useTransactionObject,useGuidKey} from "../common/hooks/transactions/useTransactionSelectors";
import {LoadingBox} from "../../common/box/loadingBox";
import {TextBox} from "../../common/textBox/textBox";
import {PrivilegesChecker} from "../../common/privileges/privilegesChecker";
import {ButtonBox} from "../../common/button/button";
import {useFormikContext} from "formik";

interface RegisterTransactionSummaryProps extends HasFormIdModel {
    transactionType: DailyTransactionTypeEnum;
}
export const RegisterTransactionSummary= forwardRef(
    ({transactionType,formId,}: RegisterTransactionSummaryProps,ref
    ) => {
        //#region state & hooks
        const { handleSubmit, handleReset } = useFormikContext<TransactionDetailResponseModel>(); // Get form context
        const request = useTransactionObject();
        const loading = useTransactionLoading();
        const guidKey = useGuidKey();
        const [isMobile,setIsMobile] = useState(window.innerWidth < 600);
        const [isVisible, setIsVisible] = useState(true);
        //#endregion
        //#region useEffect
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 600);
            };
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
        //#endregion
        //#region html
        return (
            <div>
                {loading && <LoadingBox />}
                {isVisible && (
                            <div className="d-flex flex-lg-nowrap flex-wrap justify-content-between align-items-center gap-3 w-100 p-1">
                                {/* Total */}{/* request?.TotalMonyInCurrency */}
                                <div className="d-flex align-items-center gap-2 flex-grow-1">
                                    <label className="fw-bold">{getLabelName("Total")}</label>
                                    <TextBox
                                        labelName=""
                                        inputName="totalMoneyInCurrency"
                                        inputValue={request?.TotalMonyInCurrency  ?? 0}
                                        formatType="decimal"
                                        isReadOnly={true}
                                    />
                                </div>

                                {/* Tax Value */} {/* request?.TotalTaxInCurrency */}
                                <div className="d-flex align-items-center gap-2 flex-grow-1">
                                    <label className="fw-bold">{getLabelName("Tax_Value")}</label>
                                    <TextBox
                                        labelName=""
                                        inputName="taxValueInCurrency"
                                        inputValue={request?.TotalTaxInCurrency  ?? 0}
                                        formatType="decimal"
                                        isReadOnly={true}
                                    />
                                </div>

                                {/* Net Bill */}{/* request?.TotalNetInCurrency */}
                                <div className="d-flex align-items-center gap-2 flex-grow-1">
                                    <label className="fw-bold">{getLabelName("Net Bill")}</label>
                                    <TextBox
                                        labelName=""
                                        inputName="netBillInCurrency"
                                        inputValue={request?.TotalNetInCurrency ?? 0}
                                        formatType="decimal"
                                        isReadOnly={true}
                                    />
                                </div>

                                {/* Actions */}
                                <div className="d-flex align-items-center gap-2 flex-grow-1">
                                    {request?.TransactionDetaillist && request.TransactionDetaillist.length  > 0 && (
                                        <PrivilegesChecker
                                            formId={formId}
                                            action={request.rowState==Number(RowStateEnum.View) ?"EnableView": request?.ID === 0 ? "EnableSave" : "EnableUpdate"}
                                        >
                                            <ButtonBox
                                                iconType="content-save"
                                                type="submit"
                                                className="btn btn-sm btn-gradient-primary"
                                            >
                                                {getLabelName(`${request?.ID === 0 ? "Save" : "Update"}`)}
                                            </ButtonBox>
                                        </PrivilegesChecker>
                                    )}

                                    <ButtonBox
                                        iconType="receipt"
                                        variant="danger"
                                        type="button"
                                        className="btn btn-sm"
                                        onClick={handleReset}
                                    >
                                        {getLabelName("New")}
                                    </ButtonBox>

                                    {isMobile && (
                                        <button
                                            onClick={() => setIsVisible(false)}
                                            className="btn btn-danger btn-sm ms-auto"
                                            type="button"
                                        >
                                            Close
                                        </button>
                                    )}
                                </div>
                            </div>
                )}
                {!isVisible && isMobile && (
                    <div
                        onClick={() => setIsVisible(true)}
                        style={{
                            position: "fixed",
                            bottom: "30px",
                            right: "20px",
                            backgroundColor: "#fe7c96",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                            cursor: "pointer",
                            zIndex: 2000,
                        }}
                        title="Show Summary Box"
                    >
                        +
                    </div>
                )}
            </div>
        );
        //#endregion
    });